import { useCallback, useContext } from 'react';

import PropTypes from 'prop-types';

import { AuthContext } from '../../../../../actions/auth-context';
import {
  startPlotterTheOrder,
  finishPlotterTheOrder,
} from '../../../../../actions/order.service';
import ActionModal from './ActionModal';

const PrintModal = ({ order, setOrder }) => {
  const { setLoading } = useContext(AuthContext);

  const uploadOrder = useCallback((response) => {
    if (!response.error) {
      response.delivery_date = new Date(response.delivery_date);

      if (response.payment_first_date) {
        response.payment_first_date = new Date(
          response.payment_first_date.replace(/-/g, ',')
        );
      }

      setOrder(response);
    }
  }, []);

  const getPlotterOrder = useCallback(async (data) => {
    setLoading(true);

    const response = await startPlotterTheOrder(data.order_id, data);

    uploadOrder(response);

    setLoading(false);
  }, []);

  const finishPlotterOrder = useCallback(async (data) => {
    setLoading(true);

    const response = await finishPlotterTheOrder(data.order_id, data);

    uploadOrder(response);

    setLoading(false);
  }, []);

  return (
    <>
      <ActionModal
        modal_id="modal-start-plotter-order"
        title="iniciar plotter do pedido?"
        action={getPlotterOrder}
        order={order}
      />

      <ActionModal
        modal_id="modal-finish-plotter-order"
        title="finalizar plotter do pedido?"
        action={finishPlotterOrder}
        order={order}
      />
    </>
  );
};

PrintModal.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string,
    order_status: PropTypes.string,
  }).isRequired,
  setOrder: PropTypes.func.isRequired,
};

export default PrintModal;
